if (window.jQuery) {
    (function ($, sitenav) {
        "use strict";
        sitenav = sitenav || (window.sitenav = {});
        sitenav.App = sitenav.App || (sitenav.App = {});

        sitenav.App.ReturnUrlBuilder = {
            appendReturnUrl: function () {
                var currentUrl = location.href;

                $(".append-return-url").each(function (idx, data) {
                    var href = $(data).attr("href");

                    const signOutLink = $(data).data("signout");
                    const shouldAppend = !(signOutLink && href.indexOf(location.host) > -1);
                    const returnUrlKey = $(data).data("returnUrlKey") ? $(data).data("returnUrlKey") : "ret";

                    if (!shouldAppend) return;

                    href += href.indexOf("?") > -1 ? "&" : "?";

                    // if its seller.carsalesnetwork then we always want to return to the homepage of the hero site
                    if (currentUrl.indexOf("seller.carsalesnetwork") > -1) {
                        let heroSiteDomain = $(data).data("hero-site-domain");

                        if (heroSiteDomain.indexOf("http://") === -1) {
                            heroSiteDomain = `http://${heroSiteDomain}`;
                        }

                        href += `src=sitenav&${returnUrlKey}=${encodeURIComponent(heroSiteDomain)}`;
                    } else {

                        href += `src=sitenav&${returnUrlKey}=${encodeURIComponent(currentUrl)}`;
                    }

                    const tracking = $(data).data("tracking");
                    if (tracking && tracking.length > 0) {
                        href += `&${tracking}`;
                    }

                    $(data).attr("href", href);
                });
            }
        };

        sitenav.App.ReturnUrlBuilder.appendReturnUrl();
    }(jQuery, window.sitenav));
}